'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var EC = require('elliptic').ec;

var ec = new EC('secp256k1');
module.exports = {
  verify: function () {
    var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signature, publicKey, data) {
      var res, key;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (signature) {
                _context.next = 2;
                break;
              }

              throw new Error('No signature given');

            case 2:
              if (publicKey) {
                _context.next = 4;
                break;
              }

              throw new Error('Given publicKey was undefined');

            case 4:
              if (data) {
                _context.next = 6;
                break;
              }

              throw new Error('Given input data was undefined');

            case 6:
              res = false;
              key = ec.keyPair({
                pub: publicKey,
                pubEnc: 'hex'
              });

              try {
                res = ec.verify(data, signature, key);
              } catch (e) {// Catches 'Error: Signature without r or s'
              }

              return _context.abrupt("return", Promise.resolve(res));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function verify(_x, _x2, _x3) {
      return _verify.apply(this, arguments);
    }

    return verify;
  }()
};